import { Component } from '@angular/core';
import { WindowRef } from '@spartacus/core';
import { HamburgerMenuService } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Component({
  selector: 'cx-hamburguer-menu',
  templateUrl: './hamburguer-menu.component.html',
  styleUrl: './hamburguer-menu.component.scss',
  standalone: false,
})
export class CustomHamburguerMenuComponent {
  constructor(
    private hamburgerMenuService: HamburgerMenuService,
    private winRef: WindowRef,
  ) {}

  toggle(): void {
    this.hamburgerMenuService.toggle();
  }

  get isExpanded(): Observable<boolean> {
    return this.hamburgerMenuService.isExpanded;
  }
}
